// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content__2dXyg","select":"index_select__2dEPk","btn":"index_btn__2nhsI"};